module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joseph Vukov\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Joseph Vukov")]), _vm._v(" is assistant professor of philosophy and graduate program director in the philosophy department at Loyola University Chicago.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HkIRPL/tc-custom/9781467463256.jpg?1728851812893",
      "alt": "This image is the cover for the book Navigating Faith and Science"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Navigating Faith and Science\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Religious belief is often perceived as being in conflict with science—but does it have to be?")])]), _c('p', [_vm._v("Not usually, says Joseph Vukov. In this short, accessible guide, Vukov advances three models for Christians to utilize when navigating the relationship between science and faith: conflict, independence, and dialogue. He argues that dialogue is the ideal model to follow most of the time—but not necessarily "), _c('i', [_vm._v("all")]), _vm._v(" the time. Through a philosophical approach grounded in compelling real-world examples, Vukov shows how no single model can be universally adequate, and how Christians must proceed with discernment according to the nature of the matter at hand. ")]), _c('p', [_vm._v("Considering a wide variety of illustrative issues—including cosmology, evolutionary biology, extraterrestrial life, miracles, brain death, and theoretical physics—Vukov introduces and describes each of the three models of interaction between faith and science, surveys their applications, and evaluates the effectiveness of each. Throughout, he encourages Christians to embrace a spirit of intellectual humility and remember that, at their best, faith and science converge in their relentless human pursuit of truth.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0